var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolAdmin',{attrs:{"user":_vm.user,"tool-id":"CustomerServiceSmartSearch","tool-name":"Smart Search","tool-icon":"mdi-magnify"}})
}
var staticRenderFns = []

export { render, staticRenderFns }